document.addEventListener("DOMContentLoaded", function () {
  // de 站点重定向
  if (window.location.href === "https://www.doogee.com/de/products/v40-pro") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/v40-pro";
  }
  if (window.location.href === "https://www.doogee.com/de/products/v-max-plus") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/doogee-v-max-plus";
  }
  if (window.location.href === "https://www.doogee.com/de/products/doogee-s200x") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/s200x";
  }
  if (window.location.href === "https://www.doogee.com/de/products/doogee-blade-gt") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/blade-gt";
  }

  // 检查当前 URL 是否是目标 URL
  if (window.location.href === "https://www.doogee.com/de/products/t30-max") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/doogee-t30-max-tablet-pcs-12-4-ips-4k-display-20-512gb-android-14";
  }
  if (window.location.href === "https://www.doogee.com/de/products/s-cyber") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/scyber";
  }
  if (window.location.href === "https://www.doogee.com/de/products/s-punk") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/s-punk";
  }
  if (window.location.href === "https://www.doogee.com/de/products/blade10-pro") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/blade10-pro";
  }

  // 检查当前 URL 是否是目标 URL
  if (window.location.href === "https://www.doogee.com/de/products/blade10-ultra") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/blade10-ultra";
  }
  if (window.location.href === "https://www.doogee.com/de/products/blade10-max") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/blade10-max";
  }
  if (window.location.href === "https://www.doogee.com/de/products/doogee-blade-10-power") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/products/blade10-power";
  }
  if (window.location.href === "https://www.doogee.com/de/collections/rugged-phones") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/collections/robustes-telefon";
  }

  if (window.location.href === "https://www.doogee.com/de/collections/accessories") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/collections/zubehor";
  }
  if (window.location.href === "https://www.doogee.com/de/collections/smart-tablet") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/collections/tablet";
  }
  if (window.location.href === "https://www.doogee.com/de/collections/s-series") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/collections/s-serie";
  }
  if (window.location.href === "https://www.doogee.com/de/collections/blade-series") {
      // 重定向到新 URL
      window.location.href = "https://de.doogee.com/collections/blade-serie";
  }

   // it站点重定向
   if (window.location.href === "https://www.doogee.com/it/products/v40-pro") {
    // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/v40-pro";
  }
  if (window.location.href === "https://www.doogee.com/it/products/v-max-plus") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/v-max-plus";
  }
  if (window.location.href === "https://www.doogee.com/it/products/doogee-blade-gt") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-blade-gt";
  }
  if (window.location.href === "https://www.doogee.com/it/products/s200") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/s200";
  }

  // 检查当前 URL 是否是目标 URL
  if (window.location.href === "https://www.doogee.com/it/products/fire-6") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-fire-6";
  }
  if (window.location.href === "https://www.doogee.com/it/products/doogee-s200x") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-s200x";
  }
  if (window.location.href === "https://www.doogee.com/it/products/v-max-pro") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/v-max-pro";
  }
  if (window.location.href === "https://www.doogee.com/it/products/v40") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/v40";
  }

  // 检查当前 URL 是否是目标 URL
  if (window.location.href === "https://www.doogee.com/it/products/blade10-ultra") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/blade10-ultra";
  }
  if (window.location.href === "https://www.doogee.com/it/products/blade10-max") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/blade10-max";
  }
  if (window.location.href === "https://www.doogee.com/it/products/blade10-pro") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/blade10-pro";
  }
  if (window.location.href === "https://www.doogee.com/it/products/blade10") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/blade10";
  }

  if (window.location.href === "https://www.doogee.com/it/products/doogee-fire-6-power") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-fire-6-power";
  }
  if (window.location.href === "https://www.doogee.com/it/products/s-cyber") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/s-cyber";
  }
  if (window.location.href === "https://www.doogee.com/it/products/dk10") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-dk10";
  }
  if (window.location.href === "https://www.doogee.com/it/products/v31gt") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-v31gt";
  }
  
  if (window.location.href === "https://www.doogee.com/it/products/v20s") {
    // 重定向到新 URL
    window.location.href = "https://it.doogee.com/products/doogee-v20s";
  }
  if (window.location.href === "https://www.doogee.com/it/products/v-max") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-v-max";
  }
  if (window.location.href === "https://www.doogee.com/it/products/v30pro") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/v30pro";
  }
  if (window.location.href === "https://www.doogee.com/it/products/shipping-insurance-2-years-warranty") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/shipping-insurance";
  }

  if (window.location.href === "https://www.doogee.com/it/products/s118") {
    // 重定向到新 URL
    window.location.href = "https://it.doogee.com/products/doogee-s118";
  }
  if (window.location.href === "https://www.doogee.com/it/products/t30-max") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-t30-max";
  }
  if (window.location.href === "https://www.doogee.com/it/products/t40-pro-v") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-t40-pro-v";
  }
  if (window.location.href === "https://www.doogee.com/it/products/r20") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-r20";
  }
    if (window.location.href === "https://www.doogee.com/it/products/t30-ultra") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-t30-ultra";
  }
  if (window.location.href === "https://www.doogee.com/it/products/t20ultra") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-t20ultra";
  }
  if (window.location.href === "https://www.doogee.com/it/products/t30se") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-t30se";
  }

  if (window.location.href === "https://www.doogee.com/it/products/65w-charger") {
    // 重定向到新 URL
    window.location.href = "https://it.doogee.com/products/doogee-65w-fast-charger";
  }
  if (window.location.href === "https://www.doogee.com/it/products/wireless-charger-holder") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/supporto-di-ricarica-wireless";
  }
    if (window.location.href === "https://www.doogee.com/it/products/pencil-2") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/doogee-pencil-2";
  }
  if (window.location.href === "https://www.doogee.com/it/products/keyboard-for-t30max") {
      // 重定向到新 URL
      window.location.href = "https://it.doogee.com/products/t30max-tastiera";
  }


  // es站点重定向
  if (window.location.href === "https://www.doogee.com/es/products/doogee-blade-gt") {
    // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-blade-gt";
  }
  if (window.location.href === "https://www.doogee.com/es/products/v-max-plus") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-v-max-plus";
  }
  if (window.location.href === "https://www.doogee.com/es/products/fire-6") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-fire-6";
  }
  if (window.location.href === "https://www.doogee.com/es/products/doogee-s200x") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-s200x";
  }

  // 检查当前 URL 是否是目标 URL
  if (window.location.href === "https://www.doogee.com/es/products/blade10-max") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-blade10-max";
  }
  if (window.location.href === "https://www.doogee.com/es/products/v-max-pro") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-v-max-pro";
  }
  if (window.location.href === "https://www.doogee.com/es/products/s200") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-s200";
  }
  if (window.location.href === "https://www.doogee.com/es/products/v31gt") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/v31gt";
  }
  if (window.location.href === "https://www.doogee.com/es/products/dk10") {
    // 重定向到新 URL
    window.location.href = "https://es.doogee.com/products/doogee-dk10";
  }
  if (window.location.href === "https://www.doogee.com/es/products/v20s") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-v20s";
  }
  if (window.location.href === "https://www.doogee.com/es/products/s118") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-s118";
  }
  if (window.location.href === "https://www.doogee.com/es/products/doogee-fire-6-power") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-fire-6-power";
  }

  if (window.location.href === "https://www.doogee.com/es/products/v40") {
    // 重定向到新 URL
    window.location.href = "https://es.doogee.com/products/doogee-v40";
  }
  if (window.location.href === "https://www.doogee.com/es/products/blade10-ultra") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-blade10-ultra";
  }
  if (window.location.href === "https://www.doogee.com/es/products/t40-pro-v") {
    // 重定向到新 URL
    window.location.href = "https://es.doogee.com/products/doogee-t40-pro";
  }
  if (window.location.href === "https://www.doogee.com/es/products/t30-max") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-t30-max";
  }
  if (window.location.href === "https://www.doogee.com/es/products/t30-ultra") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-t30-ultra-tablet-pc";
  }
  if (window.location.href === "https://www.doogee.com/es/products/t20ultra") {
      // 重定向到新 URL
      window.location.href = "https://es.doogee.com/products/doogee-t20-ultra-tablet";
  }

  if (window.location.href === "https://au.doogee.com/pages/manual") {
      // 重定向到新 URL
      window.location.href = "https://regionalaccessnetwork.com/doogee-service";
  }

});